import server from 'common/utils/server';

// Adds employees to `state.employees` and `state.employeesById`.
// Does not replace or remove any employee object.
function loadEmployeesIntoState(state, employees) {
  const employeesById = { ...state.employeesById };
  employees.forEach(employee => {
    employeesById[employee.id] = employee;
  });
  return {
    ...state,
    employees: Object.values(employeesById),
    employeesById,
  };
}

export function employeeState(
  state = {
    employees: [],
    employeesById: {},
    loaded: false,
    loading: false,
  },
  action
) {
  switch (action.type) {
    case 'INITIALIZATION_DATA': {
      const { currentPerson } = action.data;
      if (!currentPerson) return state;
      return loadEmployeesIntoState(state, [currentPerson]);
    }
    case 'STARTED_LOADING_EMPLOYEES': {
      return { ...state, loading: true };
    }
    case 'RECEIVED_EMPLOYEES': {
      return {
        ...loadEmployeesIntoState(state, action.employees),
        loaded: true,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
}

async function doGetEmployees(dispatch, employeesEndpointParams = {}) {
  dispatch({ type: 'STARTED_LOADING_EMPLOYEES' });
  let employees;
  try {
    const response = await server.get(
      '/api/v1/employees',
      employeesEndpointParams
    );
    employees = response.employees;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // They do not have permission to list employees
      employees = [];
    } else {
      throw error;
    }
  }
  dispatch({ type: 'RECEIVED_EMPLOYEES', employees });
}

// Deprecated.
// Please create a separate hook (and state module if necessary) if you
// need to load a specific subset of employees.
export const getEmployees =
  ({ employeeIds }) =>
  async dispatch => {
    await doGetEmployees(dispatch, { ids: employeeIds });
  };

export const getAllEmployeeData = (rbacProductAreaContext, includeDeactivated = true) => async (dispatch, getState) => {
  const { employeeState } = getState();
  if (employeeState.loading) return;

  await doGetEmployees(dispatch, { product_area: rbacProductAreaContext, include_deactivated: includeDeactivated });
};
